import { isDevEnv, isTestEnv } from '../config';

export const getRevision = () => (isDevEnv() || isTestEnv() ? '' : '');

export const getReferenceRoute = () => `reference/v2${getRevision()}`;
const getHealthPictureRevision = () => (isDevEnv() || isTestEnv() ? '' : '');
export const getIdentityRoute = () => `identity/v2${getRevision()}`;
export const getHealthPictureRoute = () => `healthpicture/v1${getHealthPictureRevision()}`;
export const getCommunityRoute = () => `community/v2${getRevision()}`;
export const getCommunityRouteV3 = () => `community/v3${getRevision()}`;
export const getNotificationsRoute = () => `notification/v1${getRevision()}`;
export const getStoriesRoute = () => `stories/v1${getRevision()}`;
export const getSearchRoute = () => `search/v3${getRevision()}`;
export const getMediaRoute = () => `media/v1${getRevision()}`;
export const getMediaRouteV3 = () => `media/v3${getRevision()}`;
export const getCommonRoute = () => `comms/v1${getRevision()}`;
export const getSentryRoute = () => 'sentry/v1';
export const getB2cRoute = () => `b2c/v1${getRevision()}`;
export const getVerificationEmailIdentityRoute = () =>
  `identity/v2${getRevision()}`;
export const getAIRoute = () => `ai/v3${getRevision()}`;

const getEnvName = () => (isDevEnv() ? 'DEV' : isTestEnv() ? 'TEST' : '');

export const getDisplayDev = () =>
  isDevEnv() || isTestEnv() ? `ENV: ${getEnvName()}${getRevision()}` : '';
